import { Container, Typography } from "@mui/material";
import React from "react";
import classes from "../Styles/blog.module.css";

const Blog = () => {
  return (
    <Container
      disableGutters
      maxWidth="xl"
      className={classes.blog_body}
      sx={{
        height: { xs: "85vh", md: "85vh" },
        pl: { xs: 3, md: 20 },
        pr: { xs: 3, md: 20 },
        pt: { xs: 10, md: 0 },
        pb: { xs: 18, sm: 30, md: 0 },
      }}
    >
      <Typography className={classes.intro_text} sx={{ py: 4 }}>
        Blog
      </Typography>
    </Container>
  );
};

export default Blog;
